import { Workflows } from '../../../../api/api-workflows';
import * as types from '../constants/action-types';

const fetchWorkflowRequest = (data) => {
  return {
    type: types.WORKFLOWS_FETCH_REQUEST,
    data
  };
};

const fetchWorkflowSuccess = (data) => {
  return {
    type: types.WORKFLOWS_FETCH_SUCCESS,
    data
  };
};

const fetchWorkflowFailure = (fetchError) => {
  return {
    type: types.WORKFLOWS_FETCH_FAILURE,
    fetchError
  };
};

export const fetchWorkflows = (query, token) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchWorkflowRequest());

      Workflows.read(query, token, (response) => {
        if (200 === response.statusCode) {
          dispatch(fetchWorkflowSuccess(response));

          return resolve(response);
        }

        const error = (response || {}).error;
        dispatch(fetchWorkflowFailure(error));

        return reject(error);
      });
    });
  };
};
